import { canActivateKitWithMobileApp } from 'helpers';

import KitActivationStepNoAuth from './KitActivationStepNoAuth';
import NativeKitActivation from './NativeKitActivation';

const ActivateKitRoute = () =>
  canActivateKitWithMobileApp() ? (
    <NativeKitActivation />
  ) : (
    <KitActivationStepNoAuth />
  );

export default ActivateKitRoute;
